








































































































































































































































































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';

import { Snotify } from '@/snotify/Snotify';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import Confirmation from '@/components/Confirmation.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { fetchMS } from '@/pantallas/Conecta/Equipos/fetchMS';
import { PermisoAccion } from '@/views/base/VariablesPermisos';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    FormFieldsContainer,
    MantenedorGrid,
    DatePicker,
    MantenedorGridSinCodigo,
    'app-confirmacion': Confirmation,
  },
})
export default class EquiposVerDetalle extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: false }) dialog: boolean;
  @Prop({ default: null }) tabs: any;
  @Prop({ required: true, default: {} }) data!: any;
  @Prop({ required: true, default: false }) statusFinished!: boolean;
  filterApi: any = {};
  Activaciones_equipos: any = {};
  isEdit: boolean = false;
  accion: string = 'VerDetalle';
  loading: boolean = true;
  paramApi: any = {
    tipoeqid: '',
    equipo: {
      tipoeqid: '',
      tipoeqname: '',
    },
    serieimei: '',
    seriecant_activa: '',
    seriebateria_fecha: '',
    tipoubicaid: '',
    costounitario: '',
    costounitario_clp: '',
    costoflete_oc: '',
    nuevoprecio_unitario: '',
    factorimportacion: '',
    nuevoprecio_unitariousd: '',
    serienumero: '',
    desinstalado: false,
  };

  accionesTotales: PermisoAccion[] = [];

  constructor() {
    super();
  }
  handleInfoGeneral() {
    this.showInfo = true;
  }

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };

  showInfo: boolean = true;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  async mounted() {
    console.log('onDialogChanged');
    try {
      await Promise.all([
        this.getFilters(),
        this.initialValues(),
        this.getEquiposActivacion(),
      ]);
    } finally {
      this.loading = false;
    }
  }

  async getEquiposActivacion() {
    const body = {
      serienumero: this.data.serienumero,
    };
    this.Activaciones_equipos = await fetchMS({
      endpoint: 'query_get_activaciones',
      body,
    });
    this.Activaciones_equipos = this.Activaciones_equipos.data;
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    console.log(id);
    return id;
  }

  closeModal() {
    console.log('closeModal Ver detalle');
    this.$emit('ModalVerDetalleEquipoEmit', false);
  }

  getCliente() {
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }

  async getFilters() {
    try {
      this.loadingService.showLoading();
      const result = await fetchMS({ endpoint: 'get_filters_edit' });
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, FILTERS } = result.data;
      if (Number(CODIGO_RESPUESTA) !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA);
        return;
      }
      this.filterApi = { ...FILTERS };
    } catch (error) {
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde'
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }

  initialValues() {
    // Validar si data trae datos, si lo hace significa que estamos editando datos
    if (Object.keys(this.data).length > 0) {
      this.paramApi = { ...this.data };
      this.paramApi.equipo = {
        tipoeqid: this.data.tipoeqid || '',
        tipoeqname: this.data.tipoeqname || '',
      };
      this.paramApi.desinstalado =
        this.data.desinstalado === 't' ? true : false;
      this.paramApi.seriebateria_fecha = this.data.seriebateria_fecha
        ? moment(this.data.seriebateria_fecha)
        : '';
      this.isEdit = false;
      this.accion = 'VerDetalle';
    }
    this.paramApi.user = localStorage.getItem('clienteDefecto') || '';
    this.paramApi.user_id = JSON.parse(localStorage.getItem('user')).id || '';
  }
} //end class
